import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EWasteLegislationComponent } from './containers/country/e-waste-legislation/e-waste-legislation.component';
import { SystemsInCountryComponent } from './containers/country/systems-in-country/systems-in-country.component';
import { VisibleFeeComponent } from './containers/country/visible-fee/visible-fee.component';
import { ReUseTargetsComponent } from './containers/country/re-use-targets/re-use-targets.component';
import { WeeeTreatmentStandardMandatoryComponent } from './containers/country/weee-treatment-standard-mandatory/weee-treatment-standard-mandatory.component';
import { RetailVsMunicipalitiesVsOtherComponent } from './containers/country/retail-vs-municipalities-vs-other/retail-vs-municipalities-vs-other.component';
import { WeeeSystemRetailVsMunicipalitiesVsOtherComponent } from './containers/weeesystem/weee-system-retail-vs-municipalities-vs-other/weee-system-retail-vs-municipalities-vs-other.component';
import { MembersAdheredComponent } from './containers/weeesystem/members-adhered/members-adhered.component';
import { NetworkRecyclingFacilitiesComponent } from './containers/weeesystem/network-recycling-facilities/network-recycling-facilities.component';
import { CollectionPointsOperatedComponent } from './containers/weeesystem/collection-points-operated/collection-points-operated.component';
import { EmployeesPerProComponent } from './containers/weeesystem/employees-per-pro/employees-per-pro.component';
import {SharedModule} from '../shared/shared.module';
import {SystemsInCountryFiltersComponent} from './components/country/systems-in-country-filters/systems-in-country-filters.component';
import {SystemsInCountryMapChartComponent} from './components/country/systems-in-country-map-chart/systems-in-country-map-chart.component';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import HC_Exporting from 'highcharts/modules/exporting';
import * as Highcharts from 'highcharts';
import HC_ExportData from 'highcharts/modules/export-data';
import {ReactiveFormsModule} from '@angular/forms';
import { EWasteLegislationFiltersComponent } from './components/country/e-waste-legislation-filters/e-waste-legislation-filters.component';
import { EWasteLegislationBarChartComponent } from './components/country/e-waste-legislation-bar-chart/e-waste-legislation-bar-chart.component';
import { VisibleFeeFiltersComponent } from './components/country/visible-fee-filters/visible-fee-filters.component';
import { VisibleFeeMapChartComponent } from './components/country/visible-fee-map-chart/visible-fee-map-chart.component';
import { ReUseTargetsFiltersComponent } from './components/country/re-use-targets-filters/re-use-targets-filters.component';
import { ReUseTargetsMapChartComponent } from './components/country/re-use-targets-map-chart/re-use-targets-map-chart.component';
import { WeeeTreatmentStandardMandatoryFiltersComponent } from './components/country/weee-treatment-standard-mandatory-filters/weee-treatment-standard-mandatory-filters.component';
import { WeeeTreatmentStandardMandatoryMapChartComponent } from './components/country/weee-treatment-standard-mandatory-map-chart/weee-treatment-standard-mandatory-map-chart.component';
import { RetailVsMunicipalitiesVsOtherFiltersComponent } from './components/country/retail-vs-municipalities-vs-other-filters/retail-vs-municipalities-vs-other-filters.component';
import { RetailVsMunicipalitiesVsOtherBarChartComponent } from './components/country/retail-vs-municipalities-vs-other-bar-chart/retail-vs-municipalities-vs-other-bar-chart.component';
import { EmployeesPerProFiltersComponent } from './components/weeesystem/employees-per-pro-filters/employees-per-pro-filters.component';
// tslint:disable-next-line:max-line-length
import { EmployeesPerProPieChartComponent } from './components/weeesystem/employees-per-pro-pie-chart/employees-per-pro-pie-chart.component';
import { CollectionPointsOperatedFiltersComponent } from './components/weeesystem/collection-points-operated-filters/collection-points-operated-filters.component';
import { CollectionPointsOperatedPieChartComponent } from './components/weeesystem/collection-points-operated-pie-chart/collection-points-operated-pie-chart.component';
import { NetworkRecyclingFacilitiesFiltersComponent } from './components/weeesystem/network-recycling-facilities-filters/network-recycling-facilities-filters.component';
import { NetworkRecyclingFacilitiesPieChartComponent } from './components/weeesystem/network-recycling-facilities-pie-chart/network-recycling-facilities-pie-chart.component';
import { MembersAdheredFiltersComponent } from './components/weeesystem/members-adhered-filters/members-adhered-filters.component';
import { MembersAdheredBarChartComponent } from './components/weeesystem/members-adhered-bar-chart/members-adhered-bar-chart.component';
import { WeeeSystemRetailVsMunicipalitiesVsOtherFiltersComponent } from './components/weeesystem/weee-system-retail-vs-municipalities-vs-other-filters/weee-system-retail-vs-municipalities-vs-other-filters.component';
import { WeeeSystemRetailVsMunicipalitiesVsOtherPieChartComponent } from './components/weeesystem/weee-system-retail-vs-municipalities-vs-other-pie-chart/weee-system-retail-vs-municipalities-vs-other-pie-chart.component';
import * as highcharts3d from 'highcharts/highcharts-3d';
import * as more from 'highcharts/highcharts-more.src';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { DownloadAtAGlanceComponent } from './components/download-at-a-glance/download-at-a-glance.component';
import {Axis} from 'highcharts';

HC_Exporting(Highcharts);
HC_ExportData(Highcharts);

Highcharts.setOptions({
  plotOptions: {
    column: {
      depth: 50,
      grouping: true,
      maxPointWidth: 100,
    },
    pie: {
      depth: 35,
      cursor: 'pointer',
    },
    columnrange: {
      maxPointWidth: 8,
      allowPointSelect: true,
      minPointLength: 5,
    },
  },
  exporting : {
    csv: {
      columnHeaderFormatter: (item: any, key: any) => {
        if (!item || item instanceof Axis) {
          return 'Country';
        } else {
          return item.name;
        }
      }
    },
    buttons: {
      contextButton: {
        menuItems:  ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG',
          'downloadCSV', 'viewData'],
      }
    },
    menuItemDefinitions: {
      downloadCSV: {
        text: 'Download data'
      }
    }
  },
  credits: {
    text: '© WEEE Forum Key Figures | Highcharts.com'
  }
});

@NgModule({
  declarations: [
    EWasteLegislationComponent,
    SystemsInCountryComponent,
    VisibleFeeComponent,
    ReUseTargetsComponent,
    WeeeTreatmentStandardMandatoryComponent,
    RetailVsMunicipalitiesVsOtherComponent,
    WeeeSystemRetailVsMunicipalitiesVsOtherComponent,
    MembersAdheredComponent,
    NetworkRecyclingFacilitiesComponent,
    CollectionPointsOperatedComponent,
    EmployeesPerProComponent,
    SystemsInCountryFiltersComponent,
    SystemsInCountryMapChartComponent,
    EWasteLegislationFiltersComponent,
    EWasteLegislationBarChartComponent,
    VisibleFeeFiltersComponent,
    VisibleFeeMapChartComponent,
    ReUseTargetsFiltersComponent,
    ReUseTargetsMapChartComponent,
    WeeeTreatmentStandardMandatoryFiltersComponent,
    WeeeTreatmentStandardMandatoryMapChartComponent,
    RetailVsMunicipalitiesVsOtherFiltersComponent,
    RetailVsMunicipalitiesVsOtherBarChartComponent,
    EmployeesPerProFiltersComponent,
    EmployeesPerProPieChartComponent,
    CollectionPointsOperatedFiltersComponent,
    CollectionPointsOperatedPieChartComponent,
    NetworkRecyclingFacilitiesFiltersComponent,
    NetworkRecyclingFacilitiesPieChartComponent,
    MembersAdheredFiltersComponent,
    MembersAdheredBarChartComponent,
    WeeeSystemRetailVsMunicipalitiesVsOtherFiltersComponent,
    WeeeSystemRetailVsMunicipalitiesVsOtherPieChartComponent,
    DownloadAtAGlanceComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        ChartModule,
        ReactiveFormsModule
    ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: () => [ highcharts3d, more, NoDataToDisplay] } // add as factory to your providers
  ]
})
export class IntelligenceModule { }
